import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, switchMap } from 'rxjs/operators';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { SidebarService } from '@cumlaude/shared-components-overlays';
import { ChatSidebarComponent } from '../../sidebars/chat/chat-sidebar.component';
import { AssistantService } from '../../services/assistant.service';
import { UserService } from '../../services/user.service';
import { GtmService } from '../../services/gtm.service';

@Component({
	selector: 'app-ai-assistent',
	templateUrl: './ai-assistent.component.html',
	styleUrls: ['./ai-assistent.component.scss'],
	imports: [ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiAssistentComponent {
	private readonly userService = inject(UserService);
	private readonly assistantService = inject(AssistantService);
	private readonly sidebarService = inject(SidebarService);
	private readonly gtm = inject(GtmService);

	assistantAvailable = toSignal(
		this.userService.rolChanged$.pipe(
			filter((rol) => rol !== undefined),
			switchMap(() => this.assistantService.isAvailable())
		),
		{ initialValue: false }
	);

	openChat() {
		this.gtm.pushEvent('assistant_open');
		this.sidebarService.open(ChatSidebarComponent, { hasBackdrop: false, allowMultiple: false });
	}
}
